import React, { useState } from 'react';

interface RecordsHoverTextProps {
  totalText: string;
  breakdownText: string;
}

export const RecordsHoverText: React.FC<RecordsHoverTextProps> = ({ totalText, breakdownText }) => {
  const [active, setActive] = useState(false);
  const ariaLabel = breakdownText ? `${totalText} (${breakdownText})` : totalText;
  return (
    <span
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
      onFocus={() => setActive(true)}
      onBlur={() => setActive(false)}
      tabIndex={breakdownText ? 0 : -1}
      aria-label={ariaLabel}
    >
      {active && breakdownText ? breakdownText : totalText}
    </span>
  );
};
